import React from "react";
import { Flex } from "@chakra-ui/react";
import TabLinkItem from "./TabLinkItem";

const TabLinks = ({ links }) => {
  return (
    <Flex direction="row" gap={2}>
      {links.map((link, index) => (
        <TabLinkItem key={index} to={link.to} icon={link.icon} label={link.label} />
      ))}
    </Flex>
  );
};

export default TabLinks;
